__turbopack_context__.v({
  "backBtn": "header-mobile-menu-module-scss-module__vH8MXW__backBtn",
  "megaMenuContentsContainer": "header-mobile-menu-module-scss-module__vH8MXW__megaMenuContentsContainer",
  "menu-list-mobile": "header-mobile-menu-module-scss-module__vH8MXW__menu-list-mobile",
  "menuActionButtonsContainer": "header-mobile-menu-module-scss-module__vH8MXW__menuActionButtonsContainer",
  "menuItemDropdown": "header-mobile-menu-module-scss-module__vH8MXW__menuItemDropdown",
  "menuItemLink": "header-mobile-menu-module-scss-module__vH8MXW__menuItemLink",
  "menuMobileContentWrapper": "header-mobile-menu-module-scss-module__vH8MXW__menuMobileContentWrapper",
  "menuMobileHeading": "header-mobile-menu-module-scss-module__vH8MXW__menuMobileHeading",
  "mobileButtonWrapper": "header-mobile-menu-module-scss-module__vH8MXW__mobileButtonWrapper",
  "subMenuItemFooter": "header-mobile-menu-module-scss-module__vH8MXW__subMenuItemFooter",
  "subMenuList": "header-mobile-menu-module-scss-module__vH8MXW__subMenuList",
  "subMenuMobileContent": "header-mobile-menu-module-scss-module__vH8MXW__subMenuMobileContent",
  "subMenuMobileContentWrapper": "header-mobile-menu-module-scss-module__vH8MXW__subMenuMobileContentWrapper",
  "subMenuMobileContentWrapper--isActive": "header-mobile-menu-module-scss-module__vH8MXW__subMenuMobileContentWrapper--isActive",
});
